import { Spin } from "antd";
import React from "react";

export function SimpleLoader() {
  return (
    <div className="flex justify-center items-center w-full py-12">
      <Spin />
    </div>
  );
}
